import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const OuterWrapper = styled(Box)(`
  & i {
    font-style: normal;
  }
  & i.highlight {
    background-color: yellow;
    color: red;
    border-radius: 3px;
    padding:0 2px;
    box-shadow: 2px 2px 2px #d3d3d3;
  }
`)
